import React from "react";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import MarketingStaffingFormContent from "Components/MarketingStaffing/MarketingStaffingFormContent";
import MarketingStaffingInfoContent from "Components/MarketingStaffing/MarketingStaffingInfoContent";
import { getPageNumber } from "Data";

const MarketingStaffingPage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateMarketingStaffing,
    currentFormData: { marketingStaffing },
  } = useFormData();

  const { updateSession, sessionData } = useSession();

  const handleSubmit = async (selectedValue) => {
    updateMarketingStaffing(selectedValue);

    await updateSession({
      current_page: getPageNumber("marketing-capabilities"),
      responses: {
        ...sessionData?.responses,
        q6_staffing: {
          staffing: selectedValue,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <FormContentWrapper
      infoContent={
        <MarketingStaffingInfoContent heading={currentPageData.pageTitle} />
      }
      formFieldContent={
        <MarketingStaffingFormContent
          submitCB={handleSubmit}
          defaultValue={marketingStaffing}
        />
      }
    />
  );
};

export default MarketingStaffingPage;
